<section class="membership-levels account-detail-section" data-testid="membership-levels-page">
  <header class="row page-header align-items-center membership-levels-page-header">
    <div class="col-12 col-lg-5">
      <h2 class="title pull-left">Membership Levels</h2>
    </div>
    <div class="col-12 col-lg-7 membership-levels-toolbar-actions">
      <div class="membership-levels-filter-wrap">
        <dx-text-box
          class="membership-levels-filter project-search"
          mode="search"
          placeholder="Name / Description / Status / Due frequency"
          [showClearButton]="true"
          valueChangeEvent="keyup"
          [width]="300"
          [value]="filterText"
          (onValueChanged)="onFilterValueChanged($event)"
        ></dx-text-box>
      </div>
      <div class="membership-levels-actions" *spHasRole="membershipManageRoles">
        <button type="button" class="btn btn-default membership-toolbar-height-btn" (click)="openImport()">Import</button>
        <button type="button" class="btn btn-success-inverted membership-toolbar-height-btn" (click)="openAdd()">
          <span class="me-1" aria-hidden="true">+</span> Add New Membership Level
        </button>
      </div>
    </div>
  </header>

  <main>
  <div *ngIf="!loading && levels.length === 0" class="empty-state-table membership-levels-empty-table">
    <div class="table-headers membership-levels-empty-headers">
      <div class="header-cell">Name</div>
      <div class="header-cell">Description</div>
      <div class="header-cell">Due Frequency</div>
      <div class="header-cell">Dues Amount</div>
      <div class="header-cell">Active Members</div>
      <div class="header-cell">Status</div>
      <div class="header-cell header-cell-actions"></div>
    </div>
    <div class="empty-state-content">
      <div class="membership-empty-message">
        <div class="membership-empty-icon">
          <i class="fa-regular fa-layer-group" aria-hidden="true"></i>
        </div>
        <h3 class="membership-empty-title">Membership Levels Not Added</h3>
        <p class="membership-empty-description">
          Add your club's membership level details to improve financial planning
        </p>
        <button
          type="button"
          class="btn btn-success-inverted membership-toolbar-height-btn"
          *spHasRole="membershipManageRoles"
          (click)="openAdd()"
        >
          <span class="me-1" aria-hidden="true">+</span> Add New Membership Level
        </button>
      </div>
    </div>
  </div>

  <div class="membership-levels-grid-wrap" *ngIf="!loading && levels.length > 0">
    <dx-data-grid
      #levelsGrid
      class="membership-levels-grid"
      [dataSource]="filteredLevels"
      keyExpr="membershipCategoryId"
      [showRowLines]="true"
      [showColumnLines]="true"
      [showBorders]="true"
      [rowAlternationEnabled]="false"
      [hoverStateEnabled]="true"
      [wordWrapEnabled]="true"
      [columnAutoWidth]="false"
      noDataText="No membership levels match your filters"
      (onSelectionChanged)="onLevelsGridSelectionChanged($event)"
      (onCellPrepared)="onLevelsGridCellPrepared($event)"
    >
    <dxo-data-grid-selection
      [mode]="canBulkAct ? 'multiple' : 'none'"
      [allowSelectAll]="false"
      [showCheckBoxesMode]="canBulkAct ? 'always' : 'none'"
    ></dxo-data-grid-selection>
    <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>
    <dxo-data-grid-paging [pageSize]="10"></dxo-data-grid-paging>
    <dxo-data-grid-pager
      [visible]="true"
      [allowedPageSizes]="[10, 25, 50, 'all']"
      [displayMode]="'compact'"
      [showPageSizeSelector]="true"
      [showInfo]="true"
      [showNavigationButtons]="true"
    ></dxo-data-grid-pager>

    <dxi-data-grid-column
      cssClass="dx-grid-cell membership-col-name"
      dataField="name"
      caption="Name"
      alignment="left"
      [width]="'16%'"
      [allowSorting]="true"
      [allowHeaderFiltering]="true"
    ></dxi-data-grid-column>
    <dxi-data-grid-column
      cssClass="dx-grid-cell membership-col-description"
      dataField="description"
      caption="Description"
      alignment="left"
      [width]="'20%'"
      [allowSorting]="true"
      [allowHeaderFiltering]="true"
    ></dxi-data-grid-column>
    <dxi-data-grid-column
      cssClass="dx-grid-cell membership-col-due-frequency"
      dataField="duesFrequency"
      caption="Due Frequency"
      alignment="left"
      [width]="158"
      [allowResizing]="false"
      [allowSorting]="true"
      [allowHeaderFiltering]="true"
    ></dxi-data-grid-column>
    <dxi-data-grid-column
      cssClass="dx-grid-cell membership-col-dues-amount"
      dataField="duesAmount"
      caption="Dues Amount"
      alignment="left"
      [width]="132"
      [allowResizing]="false"
      [allowSorting]="true"
      [allowHeaderFiltering]="true"
      cellTemplate="duesTemplate"
    >
      <div *dxTemplate="let cell of 'duesTemplate'">
        {{ cell.data.duesAmount | currency }}
      </div>
    </dxi-data-grid-column>
    <dxi-data-grid-column
      cssClass="dx-grid-cell membership-col-active-members"
      dataField="activeMembers"
      caption="Active Members"
      alignment="left"
      [width]="158"
      [allowResizing]="false"
      [allowSorting]="true"
      [allowHeaderFiltering]="true"
    ></dxi-data-grid-column>
    <dxi-data-grid-column
      cssClass="dx-grid-cell membership-col-status"
      caption="Status"
      dataField="status"
      alignment="left"
      [width]="120"
      [allowResizing]="false"
      [allowSorting]="true"
      [allowHeaderFiltering]="true"
      cellTemplate="statusTemplate"
    >
      <div *dxTemplate="let cell of 'statusTemplate'">
        <span [ngClass]="statusClass(cell.data.status)" class="ml-badge-inner">
          <i [class]="statusIconClass(cell.data.status)" aria-hidden="true"></i>
          {{ cell.data.status }}
        </span>
      </div>
    </dxi-data-grid-column>
    <dxi-data-grid-column
      cssClass="dx-grid-cell membership-col-actions"
      caption=""
      [width]="80"
      [allowResizing]="false"
      [allowSorting]="false"
      [allowHeaderFiltering]="false"
      cellTemplate="actionsTemplate"
      alignment="center"
    >
      <div *dxTemplate="let cell of 'actionsTemplate'">
        <div class="membership-grid-actions" *spHasRole="membershipManageRoles">
          <button
            type="button"
            class="edit-button"
            title="Edit membership level"
            (click)="openEdit(cell.data); $event.stopPropagation()"
          >
            <i class="fa-solid fa-pencil" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="delete-button"
            title="Delete membership level"
            (click)="requestDelete(cell.data); $event.stopPropagation()"
          >
            <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </dxi-data-grid-column>
  </dx-data-grid>
  </div>

  <div *ngIf="loading" class="p-4 text-muted">Loading…</div>
  </main>

  <sp-modal
    #editorModal
    [title]="editorTitle"
    confirmButtonText="Save"
    [keepOpenOnConfirm]="true"
    size="lg"
    (confirm)="saveEditor()"
    (cancel)="cancelEditor()"
  >
    <div class="membership-level-form">
      <form [formGroup]="membershipLevelForm">
        <div class="row">
          <div class="form-group col-md-6">
            <label for="mlName">Name *</label>
            <dx-text-box
              id="mlName"
              formControlName="name"
              [showClearButton]="true"
              [isValid]="!isFieldInvalid('name')"
              class="form-control"
            ></dx-text-box>
            <div *ngIf="isFieldInvalid('name')" class="error-message">
              {{ getErrorMessage('name') }}
            </div>
          </div>
          <div class="form-group col-md-6">
            <label for="mlDescription">Description</label>
            <dx-text-box
              id="mlDescription"
              formControlName="description"
              [showClearButton]="true"
              [isValid]="!isFieldInvalid('description')"
              class="form-control"
            ></dx-text-box>
            <div *ngIf="isFieldInvalid('description')" class="error-message">
              {{ getErrorMessage('description') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="mlDuesFrequency">Due Frequency</label>
            <dx-select-box
              id="mlDuesFrequency"
              formControlName="duesFrequency"
              [items]="frequencyOptions"
              class="form-control"
            ></dx-select-box>
          </div>
          <div class="form-group col-md-6">
            <label for="mlDuesAmount">Dues Amount</label>
            <dx-number-box
              id="mlDuesAmount"
              formControlName="duesAmount"
              [min]="0"
              format="$#,##0.####"
              [isValid]="!isFieldInvalid('duesAmount')"
              class="form-control"
            ></dx-number-box>
            <div *ngIf="isFieldInvalid('duesAmount')" class="error-message">
              {{ getErrorMessage('duesAmount') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="mlActiveMembers">Active Member Count</label>
            <dx-number-box
              id="mlActiveMembers"
              formControlName="activeMembers"
              [min]="0"
              format="#0"
              [isValid]="!isFieldInvalid('activeMembers')"
              class="form-control"
            ></dx-number-box>
            <div *ngIf="isFieldInvalid('activeMembers')" class="error-message">
              {{ getErrorMessage('activeMembers') }}
            </div>
          </div>
          <div class="form-group col-md-6">
            <label for="mlStatus">Status</label>
            <dx-select-box
              id="mlStatus"
              formControlName="status"
              [items]="statusOptions"
              class="form-control"
            ></dx-select-box>
          </div>
        </div>
      </form>
    </div>
  </sp-modal>

  <sp-membership-level-import-modal
    #levelImportModal
    (onUploaded)="onImportUploaded($event)"
  >
  </sp-membership-level-import-modal>

  <sp-modal
    #deleteConfirmModal
    title="Delete membership level"
    confirmButtonText="Delete"
    [isWarning]="true"
    (confirm)="confirmDelete()"
  >
    Are you sure you want to delete this membership level?
  </sp-modal>

  <sp-modal
    #bulkStatusModal
    title="Change status"
    confirmButtonText="Apply"
    (confirm)="confirmBulkStatus()"
  >
    <p class="small text-secondary mb-3">Apply to {{ numberOfSelectedRows }} selected level(s).</p>
    <div class="form-group mb-0">
      <label for="bulkMlStatus">New status</label>
      <dx-select-box
        id="bulkMlStatus"
        [(value)]="bulkTargetStatus"
        [items]="statusOptions"
        class="form-control"
      ></dx-select-box>
    </div>
  </sp-modal>

  <sp-modal
    #bulkDeleteModal
    title="Delete membership levels"
    confirmButtonText="Delete"
    [isWarning]="true"
    (confirm)="confirmBulkDelete()"
  >
    <p>
      Delete {{ numberOfSelectedRows }} retired level(s)? This cannot be undone.
    </p>
  </sp-modal>

  <!-- Fixed bar (not dx-toast): Toast overlay often fails to show from this route; matches Components bar visually. -->
  <div
    *ngIf="toastIsVisible"
    class="membership-bulk-action-bar"
    role="toolbar"
    aria-label="Bulk actions for selected membership levels"
  >
    <div class="membership-bulk-toast-content">
      <div class="toast-selected-container" [attr.title]="numberOfSelectedRows + ' Selected'">
        <div class="toast-selected">
          <div class="toast-selected-count-badge">{{ numberOfSelectedRows }}</div>
          <div class="toast-selected-label">Selected</div>
        </div>
      </div>
      <span class="membership-bulk-action__sep" aria-hidden="true"></span>
      <button
        type="button"
        class="membership-bulk-action__btn"
        title="Change status"
        (click)="openBulkChangeStatus()"
      >
        <i class="fa-regular fa-tags" aria-hidden="true"></i>
        <span class="membership-bulk-action__btn-text">Change status</span>
      </button>
      <span class="membership-bulk-action__sep" aria-hidden="true"></span>
      <button
        type="button"
        class="membership-bulk-action__btn"
        title="Only retired levels can be deleted in bulk."
        [disabled]="!allSelectedAreRetired"
        (click)="openBulkDelete()"
      >
        <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
        <span class="membership-bulk-action__btn-text">Delete</span>
      </button>
      <span class="membership-bulk-action__sep" aria-hidden="true"></span>
      <button
        type="button"
        class="membership-bulk-action__btn membership-bulk-action__btn--icon-only"
        title="Clear selection"
        (click)="cancelBulkActionsToast()"
      >
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</section>
